import React, { useEffect, useState, useCallback } from 'react'
import styled from 'styled-components'
import { fontSize } from '../../mixins'


const StyledList = styled.div`
  position: absolute;
  top: calc(100% + 20px);
  left: 0;
  width: 100%;
  background-color: #fff;
  list-style: none;
  box-shadow: 0 2px 10px rgba(0,0,0,.2);
  border-radius: inherit;
  padding: inherit;
  ${({show}) => show
    ? `
      opacity: 1;
      visibility: visible;
    `
    : `
      opacity: 0;
      visibility: hidden;
    `
  };
  z-index: 10;
`;

const StyledItem = styled.li`
  padding: 17px 32px;
  ${fontSize(14)};
  line-height: 17px;
  color: #101010;
  position: relative;
  cursor: pointer;
  mix-blend-mode: normal;
`;

const AddressAutocomplete = ({ show, map, address, setCoordinates, setAddress, setShowAutocomplete }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [service, setService] = useState(null);

    useEffect(() => {
        const ser = new window.google.maps.places.AutocompleteService(null, {
            types: ['geocode']
        });
        setService(ser);
    },[]);

    const setPin = item => {
        const request = {
            placeId: item.place_id,
            fields: ['name','geometry']
        };

        const placesService = new window.google.maps.places.PlacesService(map);
        placesService.getDetails(request, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                // console.log(place);
                const coords = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                };
                setCoordinates((prevState) => {
                    if (prevState !== coords) return coords
                })
            }
        });
    };

    const onSuggestionClick = (item) => () => {
        // console.log(item);
        setPin(item);
        setAddress(item.description);
        setShowAutocomplete(false)
    };

    const getSuggestions = useCallback(() => {
        return service.getQueryPredictions({ input: address }, function(predictions, status) {
            if (predictions) {
                setSuggestions(predictions);
            } else return []

        });
    }, [service, address, setSuggestions]);

    useEffect(() => {
        if (service && address) {
            getSuggestions();
        } else setSuggestions([]);
    }, [service, address, getSuggestions]);

    const renderItem = (i, index) => <StyledItem key={index} onClick={onSuggestionClick(i)}>{i.description}</StyledItem>;

    return (
        <StyledList show={show && suggestions.length}>
            {suggestions.length ? suggestions.map(renderItem) : null}
        </StyledList>
    )
};

export default AddressAutocomplete
